module.exports = __webpack_public_path__ + "static/img/no_result.67a6aff.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Material/no_result.png
// module id = 345
// module chunks = 0